module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mntrelm6-8c391ffb1488827b58b19950ca1d01e7.jpg";